    var customers = {};
    customers.ws_consult = { "NoConsult": 0, "ConsultAndExist": 1, "ConsultOnly": 2, "ConsultAndExistAndNoNetwork": 3 };

    customers.list = [
        {
            // HEPPNER FRET
            id: 1,
            activated: 1,
            code: '088',
            name: 'HeppnerFreight',
            label: 'HEPPNER',
            shipRegEx: "^[0-9]{7}$",
            colRegEx: "^[0-9]{7}$",
            wsConsult: customers.ws_consult.ConsultAndExist,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_NJU' },
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_RCA' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' },
                { code: 'ENENCF', type: 'C', lang: 'STATUS_COL_NCF' },
                { code: 'PCHMQP', type: 'C', lang: 'STATUS_COL_PAR' },
                { code: 'PCHCFM', type: 'C', lang: 'STATUS_COL_EPC' }
            ],
            agency: "000000",
            freePictures: true,
            email: true,
        },
        {
            // BMV
            id: 2,
            activated: 0,
            code: '056',
            name: 'Bmv',
            label: 'BMV',
            shipRegEx: "^9([0-9]{19})$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_ANO' },
                { code: 'LIVMQP', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "0000",
            freePictures: true,
            email: true,
            commentLength: 255
        },
        {
            // DHL FREIGHT
            id: 3,
            activated: 0,
            code: '078',
            name: 'DhlFreight',
            label: 'DHL FREIGHT',
            shipRegEx: "^[0-9]{10}$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMQP', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "P4C"
        },
        {
            // FASHION
            id: 4,
            activated: 0,
            code: '090',
            name: 'Fashion',
            label: 'FASHION PARTNER GROUP',
            shipRegEx: "^\\d{12}$",
            colRegEx: "^([0-9]{10}|[0-9]{12})$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'REFINC', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMPX', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' },
                { code: 'ENERCA', type: 'C', lang: 'STATUS_COL_REN' },
                { code: 'ENEMQP', type: 'C', lang: 'STATUS_COL_MQP' },
                { code: 'ENLCFM', type: 'C', lang: 'STATUS_COL_CFM' }
            ],
            agency: "00",
            freePictures: true
        },
        {
            // GEFCO
            id: 5,
            activated: 0,
            code: '010',
            name: 'Gefco',
            label: 'GEFCO',
            shipRegEx: "^[0-9A-Za-z $+./-]{1,23}$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMQP', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "000000"
        },
        {
            // GEODIS
            id: 6,
            activated: 0,
            code: '051',
            name: 'Geodis',
            label: 'GEODIS',
            shipRegEx: "^9([0-9]{19})$",
            wsConsult: customers.ws_consult.NoConsult,
            statusList: [
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMQP', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "000000"
        },
        {
            // HEPPNER
            id: 7,
            activated: 0,
            code: '045',
            name: 'Heppner',
            label: 'HEPPNER',
            shipRegEx: "^([0-9]{7}|[0-9]{8}|[0-9]{10})$",
            colRegEx: "^([0-9]{7}|[0-9]{8}|[0-9]{10})$",
            //delSymbology: "ITF",
            //colSymbology: "CODE_128",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMQP', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' },
                { code: 'ENERCA', type: 'C', lang: 'STATUS_COL_REN' },
                { code: 'ENEMQP', type: 'C', lang: 'STATUS_COL_MQP' },
                { code: 'ENLCFM', type: 'C', lang: 'STATUS_COL_CFM' }
            ],
            agency: "00000",
            //manifestNumber: "0:8",
            vehiculeID: "0000000",
            freePictures: true,
            email: true
        },
        {
            // HEPPNER WOEHL
            id: 8,
            activated: 1,
            code: '088',
            name: 'HeppnerWoehl',
            label: 'WOEHL',
            shipRegEx: "^[0-9]{7}$",
            colRegEx: "^[0-9]{7}$",
            wsConsult: customers.ws_consult.ConsultAndExist,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_NJU' },
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_RCA' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' },
                { code: 'ENENCF', type: 'C', lang: 'STATUS_COL_NCF' },
                { code: 'PCHMQP', type: 'C', lang: 'STATUS_COL_PAR' },
                { code: 'PCHCFM', type: 'C', lang: 'STATUS_COL_EPC' }
            ],
            agency: "000000",
            freePictures: true,
            email: true,
        },
        {
            // KIABI
            id: 9,
            activated: 0,
            code: '058',
            name: 'Kiabi',
            label: 'KIABI',
            shipRegEx: "^\\d{9}$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMQP', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "000001",
            freePictures: true
        },
        {
            // KUEHNE NAGEL (ALLOIN)
            id: 10,
            activated: 1,
            code: '033',
            name: 'KuehneNagel',
            label: 'KUEHNE+NAGEL',
            shipRegEx: "^[0-9]{2}-[0-9]{2}-[0-9]{7}$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMPQ', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "000001",
            freePictures: true,
            email: true,
            commentLength: 255
        },
        {
            // KUEHNE NAGEL FRET (ALLOIN)
            id: 11,
            activated: 0,
            code: '094',
            name: 'KuehneNagelFret',
            label: 'KUEHNE+NAGEL FRET',
            shipRegEx: "^[0-9]{8,10}$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_NJU' },
                { code: 'LIVMPQ', type: 'D', lang: 'STATUS_DEL_RCA' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "000001",
            freePictures: true,
            email: true,
            commentLength: 255
        },
        {
            // NEOPOST
            id: 12,
            activated: 0,
            code: '045',
            name: 'Neopost',
            label: 'NEOPOST',
            shipRegEx: "^\\d{7}$|^\\d{20}$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMQP', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "00000"
        },
        {
            // OFFICE DEPOT
            id: 13,
            activated: 0,
            code: '076',
            name: 'OfficeDepot',
            label: 'OFFICE DEPOT',
            shipRegEx: "^[0-9]{8,13}-[0-9]{1,3}$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMPQ', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "000"
        },
        {
            // TEMIS
            id: 14,
            activated: 0,
            code: '002',
            name: 'Temis',
            label: 'TEMIS',
            shipRegEx: "^[0-9A-Z]{4,5}$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMQP', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "0000",
            freePictures: true
        },
        {
            // SOBOTRAM
            id: 15,
            activated: 1,
            code: '022',
            name: 'Sobotram',
            label: 'SOBOTRAM',
            shipRegEx: "^[0-9]{8}$",
            colRegEx: "^[0-9]{8}$",
            wsConsult: customers.ws_consult.ConsultAndExist,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_NJU' },
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_RCA' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' },
                { code: 'ENENCF', type: 'C', lang: 'STATUS_COL_NCF' },
                { code: 'PCHMQP', type: 'C', lang: 'STATUS_COL_PAR' },
                { code: 'PCHCFM', type: 'C', lang: 'STATUS_COL_EPC' }
            ],
            agency: "000000",
            freePictures: true,
            email: true,
        },
        {
            // DUPONT BEDU
            id: 16,
            activated: 1,
            code: '022',
            name: 'DupontBedu',
            label: 'DUPONT BEDU',
            shipRegEx: "^[0-9]{8}$",
            colRegEx: "^[0-9]{8}$",
            wsConsult: customers.ws_consult.ConsultAndExist,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_NJU' },
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_RCA' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' },
                { code: 'ENENCF', type: 'C', lang: 'STATUS_COL_NCF' },
                { code: 'PCHMQP', type: 'C', lang: 'STATUS_COL_PAR' },
                { code: 'PCHCFM', type: 'C', lang: 'STATUS_COL_EPC' }
            ],
            agency: "000000",
            freePictures: true,
            email: true,
        },
        {
            // Soboroute
            id: 17,
            activated: 1,
            code: '022',
            name: 'Soboroute',
            label: 'SOBOROUTE',
            shipRegEx: "^[0-9]{8}$",
            colRegEx: "^[0-9]{8}$",
            wsConsult: customers.ws_consult.ConsultAndExist,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_NJU' },
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_RCA' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' },
                { code: 'ENENCF', type: 'C', lang: 'STATUS_COL_NCF' },
                { code: 'PCHMQP', type: 'C', lang: 'STATUS_COL_PAR' },
                { code: 'PCHCFM', type: 'C', lang: 'STATUS_COL_EPC' }
            ],
            agency: "000000",
            freePictures: true,
            email: true,
        },
        {
            // Berthelard
            id: 18,
            activated: 1,
            code: '022',
            name: 'Berthelard',
            label: 'BERTHELARD',
            shipRegEx: "^[0-9]{8}$",
            colRegEx: "^[0-9]{8}$",
            wsConsult: customers.ws_consult.ConsultAndExist,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_NJU' },
                { code: 'LIVRCA', type: 'D', lang: 'STATUS_DEL_RCA' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' },
                { code: 'ENENCF', type: 'C', lang: 'STATUS_COL_NCF' },
                { code: 'PCHMQP', type: 'C', lang: 'STATUS_COL_PAR' },
                { code: 'PCHCFM', type: 'C', lang: 'STATUS_COL_EPC' }
            ],
            agency: "000000",
            freePictures: true,
            email: true,
        },
        {
            // WELDOM
            id: 19,
            activated: 0,
            code: '083',
            name: 'Weldom',
            label: 'WELDOM',
            shipRegEx: "^\\d{8}$",
            wsConsult: customers.ws_consult.ConsultOnly,
            statusList: [
                { code: 'RENNJU', type: 'D', lang: 'STATUS_DEL_REN' },
                { code: 'LIVMPQ', type: 'D', lang: 'STATUS_DEL_MQP' },
                { code: 'LIVCFM', type: 'D', lang: 'STATUS_DEL_CFM' }
            ],
            agency: "000001",
            freePictures: true
        }
    ];
    customers.shortlist = customers.list.filter(item => item.activated !== 0).sort((a, b) => a.label.localeCompare(b.label));
    
    export default customers;